import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

export interface CoacheeProfileMeetingsState {
	readonly reloadMeetingsTrigger: number;
	readonly meetingsChunkSize: number;
	readonly meetingsOffset: number;
	readonly exportTaskId: string;
	readonly isExporting: boolean;
	readonly meetingsId: string[];
}

@Injectable()
export class CoacheeProfileMeetingsStore extends Store<CoacheeProfileMeetingsState> {
	constructor() {
		super(
			{
				meetingsId: [],
				meetingsChunkSize: 20,
				meetingsOffset: 0,
				isExporting: false,
				exportTaskId: null,
			},
			{ name: `ui-coachee-profile-meetings-${guid()}` }
		);
	}
}
